// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Section_wrapper__16ddC"};